import { addDays as dfAddDays, differenceInCalendarDays } from 'date-fns'

export type ISODate = string
type T = (key: string, opts?: any) => string

const pad = (n: number) => String(n).padStart(2, '0')

/** 'YYYY-MM-DD' → local-midnight Date. Never `new Date(iso)` (that is UTC midnight). */
export const parseIsoDate = (iso: ISODate): Date => {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y, m - 1, d)
}
export const toIsoDate = (d: Date): ISODate => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
export const todayIso = (): ISODate => toIsoDate(new Date())
export const isIsoDate = (s: string | null | undefined): s is ISODate => !!s && /^\d{4}-\d{2}-\d{2}$/.test(s) && toIsoDate(parseIsoDate(s)) === s
export const addDays = (iso: ISODate, n: number): ISODate => toIsoDate(dfAddDays(parseIsoDate(iso), n))
/** b − a in calendar days. */
export const diffDays = (a: ISODate, b: ISODate): number => differenceInCalendarDays(parseIsoDate(b), parseIsoDate(a))
/** ISO weekday: 1 = Monday … 7 = Sunday (matches the backend calendars). */
export const weekdayOf = (iso: ISODate): number => { const js = parseIsoDate(iso).getDay(); return js === 0 ? 7 : js }
export const isWeekend = (iso: ISODate): boolean => weekdayOf(iso) >= 6
export const minIso = (dates: ISODate[]): ISODate => dates.reduce((a, b) => (b < a ? b : a))
export const maxIso = (dates: ISODate[]): ISODate => dates.reduce((a, b) => (b > a ? b : a))

export const formatIsoDate = (t: T, iso?: ISODate | null): string =>
  iso ? parseIsoDate(iso).toLocaleDateString(t('date_locale') || 'en-US', { day: 'numeric', month: 'numeric', year: 'numeric' }) : ''
export const formatDays = (t: T, n: number | null | undefined): string => (n == null ? '' : `${n} ${t('Schedule_unit_days_short')}`)
